import { render, staticRenderFns } from "./HighlightsUploadWrapper.vue?vue&type=template&id=3211ee31&scoped=true"
import script from "./HighlightsUploadWrapper.vue?vue&type=script&lang=js"
export * from "./HighlightsUploadWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3211ee31",
  null
  
)

export default component.exports